/* =========================================================
   Select Your 5 Testers — Selection Logic & Cart Integration
   Vanilla JS, no external dependencies.
   Horizon-compatible: hooks into the existing product form
   (form[action*="/cart/add"]) without altering variant logic.
   ========================================================= */

(function () {
  'use strict';

  var ICON_CHECK =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var ICON_INFO =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.5"/>' +
    '<path d="M12 8v.01M12 11v5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
    '</svg>';

  function init(section) {
    var sectionId = section.getAttribute('data-block-id') || section.getAttribute('data-section-id');
    var requiredCount = parseInt(section.getAttribute('data-required-count'), 10) || 5;

    var grid = section.querySelector('[data-testers-grid]');
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-tester-card]'));
    var countEl = section.querySelector('[data-testers-count]');
    var counterEl = section.querySelector('[data-testers-counter]');
    var statusEl = section.querySelector('[data-testers-status]');
    var statusTextEl = section.querySelector('[data-testers-status-text]');
    var statusIconEl = section.querySelector('[data-testers-status-icon]');
    var fieldsContainer = section.querySelector('[data-testers-fields]');

    if (!grid || !cards.length) return;

    // Preserve order of selection so "Tester 1".."Tester N" map predictably.
    var selected = [];

    // Locate the product form on the page (Horizon: form[action*="/cart/add"]).
    var productForm = document.querySelector('form[action*="/cart/add"]');
    var submitButton = productForm
      ? productForm.querySelector('[type="submit"][name="add"], button[name="add"]')
      : null;

    function getHiddenInputsRoot() {
      // Hidden inputs must live inside the product form to be submitted with it.
      if (!productForm) return fieldsContainer;

      var root = productForm.querySelector('[data-testers-fields-clone="' + sectionId + '"]');
      if (!root) {
        root = document.createElement('div');
        root.setAttribute('data-testers-fields-clone', sectionId);
        root.hidden = true;
        productForm.appendChild(root);
      }
      return root;
    }

    function syncHiddenFields() {
      var root = getHiddenInputsRoot();
      if (!root) return;

      root.innerHTML = '';

      selected.forEach(function (name, index) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[Tester ' + (index + 1) + ']';
        input.value = name;
        root.appendChild(input);
      });
    }

    function updateSubmitButton() {
      var complete = selected.length === requiredCount;

      if (submitButton) {
        if (complete) {
          submitButton.removeAttribute('disabled');
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('testers-disabled');
        } else {
          submitButton.setAttribute('disabled', 'disabled');
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('testers-disabled');
        }
      }
    }

    function updateCounter() {
      if (countEl) countEl.textContent = selected.length;

      if (counterEl) {
        if (selected.length === requiredCount) {
          counterEl.setAttribute('data-state', 'complete');
        } else {
          counterEl.removeAttribute('data-state');
        }
      }
    }

    function updateStatus() {
      if (!statusEl || !statusTextEl) return;

      if (selected.length === requiredCount) {
        statusEl.setAttribute('data-state', 'complete');
        statusTextEl.textContent = 'You have selected your ' + requiredCount + ' testers.';
        if (statusIconEl) statusIconEl.innerHTML = ICON_CHECK;
      } else {
        statusEl.setAttribute('data-state', 'incomplete');
        statusTextEl.textContent = 'Please select exactly ' + requiredCount + ' testers to continue.';
        if (statusIconEl) statusIconEl.innerHTML = ICON_INFO;
      }
    }

    function updateCardStates() {
      var atLimit = selected.length >= requiredCount;

      cards.forEach(function (card) {
        var name = card.getAttribute('data-tester-name');
        var isSelected = selected.indexOf(name) !== -1;

        card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');

        if (!isSelected && atLimit) {
          card.setAttribute('data-disabled', 'true');
        } else {
          card.removeAttribute('data-disabled');
        }
      });
    }

    function shake(card) {
      card.classList.remove('is-shaking');
      // Restart animation.
      void card.offsetWidth;
      card.classList.add('is-shaking');
      window.setTimeout(function () {
        card.classList.remove('is-shaking');
      }, 400);
    }

    function refresh() {
      updateCardStates();
      updateCounter();
      updateStatus();
      updateSubmitButton();
      syncHiddenFields();
    }

    function toggleCard(card) {
      var name = card.getAttribute('data-tester-name');
      var index = selected.indexOf(name);

      if (index !== -1) {
        selected.splice(index, 1);
      } else {
        if (selected.length >= requiredCount) {
          shake(card);
          return;
        }
        selected.push(name);
      }

      refresh();
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        toggleCard(card);
      });

      card.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggleCard(card);
        }
      });
    });

    // Safeguard: block submission if the requirement is not met
    // (e.g. button re-enabled by other scripts, or Enter key submit).
    if (productForm) {
      productForm.addEventListener('submit', function (event) {
        if (selected.length !== requiredCount) {
          event.preventDefault();
          event.stopPropagation();
          if (statusEl) {
            statusEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          updateStatus();
        }
      });
    }

    // Initial state.
    refresh();
  }

  function boot() {
    var elements = document.querySelectorAll('.select-testers-block, .select-testers-section');
    elements.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-initialize when the block/section is reloaded by the Theme Editor.
  document.addEventListener('shopify:section:load', function (event) {
    var elements = event.target.querySelectorAll('.select-testers-block, .select-testers-section');
    elements.forEach(init);
  });
})();